// 🔒
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
const logo = new URL("../assets/logo.webp", import.meta.url).href;

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search, location.hash]);

  const closeMenu = () => setMenuOpen(false);

  const scrollToSectionOnHome = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;

    const navbar = document.querySelector(".navbar");
    const navbarHeight = navbar ? navbar.offsetHeight : 0;
    const offset = 16;

    const top =
      element.getBoundingClientRect().top +
      window.scrollY -
      navbarHeight -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  const handleSectionNavigate = (sectionId) => {
    closeMenu();

    if (isHome) {
      scrollToSectionOnHome(sectionId);
      return;
    }

    navigate(`/?scrollTo=${sectionId}`);
  };
  
  return (
    <header className="navbar">
      <div className="container navbar__inner">
        <Link to="/" className="brand" onClick={closeMenu}>
          <img src={logo} alt="ELEFIT logo" className="brand__logo" />
          <span className="brand__text">EleFit App</span>
        </Link>

        <nav className={`nav ${menuOpen ? "nav--open" : ""}`} aria-label="Main navigation">
          {/* <button
            type="button"
            className="nav__link nav__link--button"
            onClick={() => handleSectionNavigate("features")}
          >
            Features
          </button> */}

          <button
            type="button"
            className="nav__link nav__link--button"
            onClick={() => handleSectionNavigate("trainer-benefits")}
          >
            For Trainers
          </button>

          <button
            type="button"
            className="nav__link nav__link--button"
            onClick={() => handleSectionNavigate("trainers")}
          >
            For Users
          </button>

          <Link to="/faq" className="nav__link" onClick={closeMenu}>
            FAQ
          </Link>

          <button
            type="button"
            className="btn btn--small btn--primary nav__cta"
            onClick={() => handleSectionNavigate("download")}
          >
            Download
          </button>
        </nav>

        <button
        type="button"
        className={`menu-toggle ${menuOpen ? "menu-toggle--active" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <rect y="3" width="20" height="2" rx="1" fill="white"/>
            <rect y="9" width="20" height="2" rx="1" fill="white"/>
            <rect y="15" width="20" height="2" rx="1" fill="white"/>
          </svg>
        </button>
      </div>
    </header>
  );
}
// 🔒